import type { FC } from "react";
import React, { Fragment, useState } from "react";
import type {
  NavRouteItem,
  NavRouteTree,
  NestedNavRouteMenu,
} from "@/routerConfig";
import css from "./NavMenu.module.css";
import NavMenuItem from "./NavMenuItem";
import NavSection from "./NavSection";

type NavMenuProps = {
  menuItems: NavRouteTree;
  /** The section that contains the current page item */
  activeSectionLabel?: string;
};

const renderMenuItem = ({ path, label, ...restProps }: NavRouteItem) => {
  return (
    <NavMenuItem key={path} path={path} {...restProps} parentLabel="">
      {label}
    </NavMenuItem>
  );
};

const NavMenu: FC<NavMenuProps> = ({ menuItems, activeSectionLabel = "" }) => {
  const [openItem, setOpenItem] = useState(activeSectionLabel);

  return (
    <ul className={css.menuContainer}>
      {menuItems.map((item) => (
        <Fragment key={item.label}>
          {"children" in item && Array.isArray(item.children) ? (
            <NavSection
              setOpenItem={setOpenItem}
              openItem={openItem}
              isActive={activeSectionLabel === item.label}
              item={item as NestedNavRouteMenu}
            />
          ) : (
            renderMenuItem(item as NavRouteItem)
          )}
        </Fragment>
      ))}
    </ul>
  );
};

export default NavMenu;
